// extracted by mini-css-extract-plugin
export default {"root":"uWtCw","checkbox":"_xw_A","input":"iFVKN"};